import { createFileRoute } from '@tanstack/react-router';
import { getPageWithContent } from '@/services/docs';
import DocsGroupPage, { DocsGroupPageLoading } from '@/components/Docs/DocsGroupPage';

export const Route = createFileRoute('/about-legal/$section/$slug')({
  loader: async ({ params }) =>
    getPageWithContent(params.section, params.slug, 'about-legal'),
  pendingComponent: DocsGroupPageLoading,
  component: AboutLegalPage,
});

function AboutLegalPage() {
  const page = Route.useLoaderData();
  return <DocsGroupPage page={page} />;
}
